var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pieChart"}},[_c('highcharts',{attrs:{"options":_vm.chartData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }